import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';

import './index.css';
import { App } from './App';
import Loc from './Loc/Loc';

if(!localStorage.getItem('language')){
    Loc.changeLanguage(navigator.language || navigator.userLanguage);
}else{
    Loc.changeLanguage(localStorage.getItem('language'));
}

ReactDOM.render(
    <React.StrictMode>
        <RecoilRoot>
            <App />
        </RecoilRoot>
    </React.StrictMode>,
    document.getElementById('app')
);
